import { Sparkles } from 'lucide-react';
import { useAssistantUi } from './assistantUiStore';
import { useT } from '@/lib/i18n/useT';

/**
 * Caso 07 — Floating launcher rendered globally in `AdminShell`. Toggles
 * the AssistantDrawer. The button is hidden when the workspace's plan
 * lacks `featAiAssistant` — the parent shell does the gating so the launcher
 * itself stays stateless.
 */
export function AssistantLauncher() {
  const t = useT();
  const open = useAssistantUi((s) => s.open);
  const toggle = useAssistantUi((s) => s.toggle);
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={t('assistant.launcher.aria')}
      aria-pressed={open}
      /* bottom-24 on mobile clears the fixed bottom nav (h-16); md+ has no
         bottom bar so the launcher drops back to the usual bottom-6. */
      className="fixed bottom-24 right-6 z-30 inline-flex h-12 w-12 items-center justify-center rounded-full bg-[var(--color-accent)] text-[#0A0A0A] shadow-lg transition-transform hover:scale-105 print:hidden md:bottom-6 md:z-50"
    >
      <Sparkles className="h-5 w-5" />
    </button>
  );
}
